import { Bands, Glance, Intro, Reading, Weightage } from "./guide/Sections";

export default function ScoringGuide() {
  return (
    <div className="grid" data-testid="scoring-guide">
      <Intro />
      <Reading />
      <Weightage />
      <Bands />
      <Glance />
    </div>
  );
}
